<template>
	<div class="index">
		<!-- 顶部 banner -->
		<section class="head-bar">
			<div class="ad-swiper">
				<img class="ad-swiper-bg"
					v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20260119.1.png`" />
			</div>
		</section>
		<!-- 导航 -->
		<section class="menu">
			<div class="menu-bar">
				<ul>
					<li v-for="(item, index) in data_menu_array" :key="index" @click="handleClick(item.url)">
						<img v-lazy="item.icon" />
						<p>{{item.title}}</p>
					</li>
				</ul>
			</div>
		</section>
		<!-- 景区门票 -->
		<section class="list-1009">
			<div class="list-1009_title">
				<span class="title">
					<label for="">景区门票</label>
					<img class="titleImg"
						v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251127.6.png`" />
				</span>
				<img @click="handleClick('/touristIndex')" class="moreImg"
					v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251128.1.png`" />
			</div>
			<!-- tablist -->
			<div class="tablist">
				<label for="" :class="item.keyword == jqIndex?'activeTab':''" @click="jqtap(item.keyword)"
					v-for="(item, index) in region" :key="index">{{item.title}}</label>
			</div>
			<!-- 列表 -->
			<div class="list">
				<div class="list-item" v-for="(item, index) in jqList" :key="index"
					@click="handleClick('/detail?id='+item.id)">
					<img v-lazy="item.imageUrl" />
					<div class="list-item_con">
						<h2>{{item.title}}</h2>
						<span>
							<font>￥</font>
							<p>{{item.price}}</p>
							<b>起</b>
						</span>
					</div>
				</div>
			</div>
		</section>
		<!-- 东北定制游 -->
		<section class="list-1009">
			<div class="list-1009_title">
				<span class="title">
					<label for="">东北定制游</label>
					<img class="titleImg"
						v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251127.6.png`" />
				</span>
				<img @click="handleClick('/customSwim?type=DzyFl')" class="moreImg"
					v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251128.1.png`" />
			</div>
			<!-- tablist -->
			<div class="region-tab_top">
				<label for=""
					:class="[item.key == dbIndex?'lfCss':'',dzCityIndex !=0 && dzCityIndex-1== index?'rgCss':'','tab_top']"
					@click="dbtap(item.key,dbTheme,index)" v-for="(item, index) in dbRegion" :key="index">
					<p>{{item.name}}</p>
				</label>
			</div>
			<!-- <view class="region-tab_top">
				<view wx:for="{{dzCity}}" data-index="{{index}}" data-id="{{item.key}}" bindtap="clickRegion"
					class="{{picker_index == item.key ?'lfCss':''}} {{dzCityIndex !=0 && dzCityIndex-1== index?'rgCss':''}} tab_top">
					<label for="">{{item.name}}</label>
				</view>
			</view> -->
			<div class="dingBacs">
				<div class="dingBac"></div>
				<!-- tabList -->
				<div class="tablist">
					<label for="" :class="[item.theme == dbTheme?'activeTab':'','bacWhite']"
						@click="dbtap(dbIndex,item.theme,dzCityIndex)" v-for="(item, index) in tabList"
						:key="index">{{item.title}}</label>
				</div>
				<!-- 列表 -->
				<div class="list">
					<div class="list-item" v-for="(item, index) in dbList" :key="index"
						@click="handleClick('/swimDetail?id='+item.id)">
						<img v-lazy="item.picturePath" />
						<div class="list-item_con">
							<h2>{{item.title}}</h2>
							<span>
								<font>￥</font>
								<p>{{item.refPrice}}</p>
								<b>起</b>
							</span>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- 周边游 -->
		<section class="list-1009">
			<div class="list-1009_title">
				<span class="title">
					<label for="">周边游</label>
					<img class="titleImg"
						v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251127.6.png`" />
				</span>
				<img @click="handleClick('/customSwim?type=ZbyFl')" class="moreImg"
					v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251128.1.png`" />
			</div>
			<!-- tablist -->
			<div class="tablist zbClass">
				<label for="" :class="item.key == zbIndex?'activeTab':''" @click="zbtap(item.key)"
					v-for="(item, index) in zbRegion" :key="index">{{item.name}}</label>
			</div>
			<!-- 列表 -->
			<div class="list">
				<div class="list-item" v-for="(item, index) in zbList" :key="index"
					@click="handleClick('/swimDetail?id='+item.id)">
					<img v-lazy="item.picturePath" />
					<div class="list-item_con">
						<h2>{{item.title}}</h2>
						<span>
							<font>￥</font>
							<p>{{item.refPrice}}</p>
							<b>起</b>
						</span>
					</div>
				</div>
			</div>
		</section>
		<!-- 全球签证 -->
		<!-- <section class="list-1009">
			<div class="list-1009_title">
				<span class="title">
					<label for="">全球签证</label>
					<img class="titleImg"
						v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251127.6.png`" />
				</span>
				<img @click="$router.push({ path: '/visa'})" class="moreImg"
					v-lazy="`https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251128.1.png`" />
			</div>
			<div class="tablist qzClass">
				<label for="" :class="item.continentId == qzIndex?'activeTab':''" @click="qztap(item.continentId)"
					v-for="(item, index) in qzRegion" :key="index">{{item.name}}</label>
			</div>
			<div class="list">
				<div class="list-item" v-for="(item, index) in qzList" :key="index"
					@click="$router.push({path: '/swimDetail',query: {id: item.id}})">
					<img v-lazy="item.picturePath" />
					<div class="list-item_con">
						<h2>{{item.title}}</h2>
						<span>
							<font>￥</font>
							<p>{{item.refPrice}}</p>
							<b>起</b>
						</span>
					</div>
				</div>
			</div>
		</section> -->
		<section class="tabbar">
			<Footer :active="meActive" @need-login="showLogin = true" />
		</section>
		<Login v-model="showLogin" />
		<div style="width: 100%;height: 100px;"> </div>
	</div>
</template>

<script>
	import {
		mapMutations,
		mapGetters
	} from 'vuex'
	import {
		Toast,
		Dialog
	} from 'vant'
	import Footer from '@/components/Footer.vue'
	import List from '@/components/List.vue'
	import Login from '@/components/login.vue'
	export default {
		name: 'index',
		components: {
			Footer,
			List,
			Login
		},
		data() {
			return {
				meActive: 0,
				random: 0,
				data_menu_array: [],
				token: "",
				showLogin: false,
				region: [],
				jqIndex: "",
				qzIndex: "",
				qzList: [],
				jqList: [],
				qzRegion: [],
				zbRegion: [],
				zbList: [],
				zbIndex: "",
				dbRegion: [],
				dbList: [],
				dbIndex: "",
				tabList: [],
				dbTheme: "",
				dzCityIndex: 0
			};
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			this.random = Math.random()
			// if (!(this.userInfo && this.userInfo.userId)) {
			// 	let code = this.getUrlKey("code");
			// 	if (code) {
			// 		console.log(code)
			// 		this.$post(this.$apiWebsiteSweet + "/api/GetUserInfo?code=" + code).then(res => {
			// 			console.log(res.OpenId)
			// 			this.openId = res.OpenId
			// 			localStorage.setItem('openId', res.OpenId)
			// 		})
			// 	} else {
			// 		this.getCodeApi("123");
			// 	}
			// }
			this.getJqCity()
			this.getDbCity()
			// this.getQzCity()
			this.getZbCity()
		},
		mounted() {
			this.setImageMenu()
		},
		methods: {
			...mapMutations('account', ['setUserInfo', 'setUserTokenNew']),
			getCodeApi(state) { //获取code
				let urlObj = new URL(window.location.href);
				urlObj.searchParams.delete('code');
				urlObj.searchParams.delete('state');
				let urlNow = encodeURIComponent(urlObj.toString());
				let scope = 'snsapi_userinfo'; //snsapi_userinfo   //静默授权 用户无感知
				let appid = 'wxe263bde2c946609b';
				let url =
					`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
				window.location.replace(url);
			},
			getUrlKey(name) { //获取url 参数
				return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location
					.href) || [,
					""
				])[1].replace(/\+/g, '%20')) || null;
			},
			// 景点门票城市
			getJqCity() {
				this.$get(this.$login + '/api/GetAppMenuList', {}).then(res => {
					var region = res.data.find(item => item.areaNo === 17).items[0].items
					this.region = region
					this.jqIndex = region[0].keyword
					this.jqtap(region[0].keyword)
				})
			},
			jqtap(e) {
				this.jqIndex = e
				this.$post(this.$login + '/api/services/app/NewNearTravel/GetNearTravel_List', {
					"keyWord": e,
					"pageIndex": 1,
					"pageSize": 4,
					"organizationId": this.$organizationId,
					"isZeroShow": false
				}).then(res => {
					console.log(res)
					this.jqList = res.result.tag.tagProductList
				})
			},
			getQzCity() {
				this.$_post(this.$connectHttpDayun + '/erpteam/teampro/api/getcontinent', {}).then(res => {
					this.qzRegion = res
					this.qzIndex = res[0].continentId
					this.qztap(res[0].continentId)
				})
			},
			qztap(e) {
				this.qzIndex = e
				this.$_post(this.$connectHttpDayun + '/team/mobile/indirect/pagefxwdcj', {
					"pageIndex": 1,
					"pageSize": 4,
					"object": {
						"platformid": this.$platformid,
						"is_sny": 2,
						"isself": 0,
						"proProperty": 2,
						"continentArr": e
					}
				}).then(res => {
					console.log(res)
					this.qzList = res.objects
				})
			},
			getZbCity() {
				this.$_post(this.$connectHttpDayun + '/erpteam/teampro/api/getapt', {
					type: 'ZbyFl'
				}).then(res => {
					this.zbRegion = res.slice(0, 4)
					this.zbIndex = res[0].key
					this.zbtap(res[0].key)
				})
			},
			zbtap(e) {
				this.zbIndex = e
				this.$_post(this.$connectHttpDayun + '/team/mobile/indirect/pagefxwd', {
					"pageIndex": 1,
					"pageSize": 4,
					"object": {
						'theme': "44",
						'platformid': this.$platformid,
						'is_sny': 1,
						'zoneString': e
					}
				}).then(res => {
					console.log(res)
					this.zbList = res.objects
				})
			},
			async getDbCity() {
				try {
					const [userResponse, postResponse] = await Promise.all([
						this.$_post(this.$connectHttpDayun + '/erpteam/teampro/api/getapt', {
							type: 'DzyFl'
						}),
						this.$get(this.$login + '/api/GetAppMenuList', {})
					])
					this.dbRegion = userResponse.slice(0, 4)
					this.dbIndex = userResponse[0].key
					var tabList = postResponse.data.find(item => item.areaNo === 5).items[0].items
					tabList.forEach(function(item) {
						item.theme = JSON.parse(item.param).theme
					})
					this.tabList = tabList
					this.dbTheme = tabList[0].theme
					this.dbtap(userResponse[0].key, tabList[0].theme, 0)
				} catch (err) {
					this.error = err.message
				}
			},
			dbtap(e, theme, index) {
				this.dbIndex = e
				this.dbTheme = theme
				this.dzCityIndex = index
				this.$_post(this.$connectHttpDayun + '/team/mobile/indirect/pagefxwd', {
					"pageIndex": 1,
					"pageSize": 4,
					"object": {
						'theme': theme,
						'platformid': this.$platformid,
						'is_sny': 1,
						'zoneString': e
					}
				}).then(res => {
					console.log(res)
					this.dbList = res.objects
				})
			},
			// 图标导航
			setImageMenu() {
				this.data_menu_array = [{
						icon: 'https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/index/ico_1jqmp.png',
						title: '景点门票',
						url: '/touristIndex'
					},
					{
						icon: 'https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/index/ico_3dbdz.png',
						title: '东北定制游',
						url: '/customSwim?type=DzyFl'
					},
					{
						icon: 'https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/zby.png',
						title: '周边游',
						url: '/customSwim?type=ZbyFl'
					},
					// {
					// 	icon: 'https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/qyqz.png',
					// 	title: '全球签证',
					// 	url: '/visa'
					// }
				]
			},
			toast() {
				Toast("敬请期待")
			},
			handleClick(url) {
				if (this.userInfo && this.userInfo.userId) {
					this.$router.push({
						path: url
					})
				} else {
					this.showLogin = true
				}
			}
		}
	}
</script>

<style scoped>
	.head-bar {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 397px;
		/* background: linear-gradient(219deg, #F8DD9C 0%, #F8D277 100%); */
		border-radius: 0 0 40px 40px;
		padding: 20px;
		box-sizing: border-box;
		z-index: 2;
		position: relative;
		background-image: url("https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/bg20260119.png");
		/* 可以添加更多的样式属性来优化显示效果 */
		background-size: cover;
		/* 覆盖整个元素，图片可能会被裁剪 */
		background-position: center;
		/* 图片居中显示 */
		background-repeat: no-repeat;
		/* 图片不重复 */
	}

	.ad-swiper {
		width: 100%;
		height: 350px;
		border-radius: 20px;
		overflow: hidden;
	}

	.ad-swiper-bg,
	.ad-swiper-bg img {
		height: 100%;
		width: 100%;
		border-radius: 20px;
	}

	/* 导航 */
	.menu {
		width: 100%;
		padding: 30px 20px;
		box-sizing: border-box;
		z-index: 2;
		position: relative;
	}

	.menu-bar,
	.menu-bar ul {
		width: 100%;
	}

	.menu-bar ul {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.menu-bar ul li {
		display: flex;
		flex-direction: column;
		align-items: center;
		flex: 1;

	}

	.menu-bar ul li p {
		color: #000;
		font-weight: bold;
		font-size: 24px;
		text-align: center;
		margin-top: 10px;
	}

	.menu-bar img {
		width: 142px;
		height: 100px;
	}


	.list-1009 {
		width: 100%;
		position: relative;
		background: linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%);
	}

	.list-1009_title {
		background-image: url("https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251127.5.png");
		/* 可以添加更多的样式属性来优化显示效果 */
		background-size: cover;
		/* 覆盖整个元素，图片可能会被裁剪 */
		background-position: center;
		/* 图片居中显示 */
		background-repeat: no-repeat;
		/* 图片不重复 */
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		padding: 40px 30px 30px 30px;
		box-sizing: border-box;
	}

	.moreImg {
		width: 61px;
		height: 33px;
	}

	.title {
		position: relative;
		font-weight: bold;
		font-size: 38px;
		color: #293243;
	}

	.title label {
		z-index: 2;
		position: inherit;
	}

	.titleImg {
		width: 97px;
		height: 26px;
		position: absolute;
		bottom: -14px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1;
	}

	.tablist {
		width: 100%;
		padding: 40px 30px 30px 30px;
		box-sizing: border-box;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 17px;
		z-index: 2;
		position: relative;
	}

	.tablist label {
		flex: 1;
		height: 48px;
		background: #E2EBFF;
		border-radius: 10px;
		font-size: 24px;
		color: #333333;
		text-align: center;
		line-height: 48px;
	}

	.bacWhite {
		background-color: #ffffff !important;
	}

	.bacWhite .activeTab,
	.activeTab {
		background-color: #6B90F2 !important;
		color: #ffffff !important;
	}

	.qzClass {
		grid-template-columns: repeat(5, 1fr) !important;
	}

	.qzClass label,
	.zbClass label {
		background-color: #D5F4EE;
	}

	.qzClass .activeTab,
	.zbClass .activeTab {
		background-color: #22CDA4 !important;
	}

	.list {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		z-index: 2;
		position: relative;
	}

	.list-item {
		display: flex;
		flex-direction: column;
		width: 345px;
		background: #ffffff;
		border-radius: 20px 20px 20px 20px;
		margin-bottom: 20px;
	}

	.list-item img {
		width: 345px;
		height: 360px;
		border-radius: 20px 20px 20px 20px;
	}

	.list-item_con {
		width: 100%;
		padding: 14px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 160px;
	}

	.list-item h2 {
		font-size: 26px;
		color: #333333;
		display: -webkit-box;
		overflow: hidden;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.list-item span {
		display: flex;
		align-items: flex-end;
		color: #E54E0C;
		font-size: 32rpx;
		font-weight: bold;
	}

	.list-item span p {
		font-size: 39px;
	}

	.list-item span b {
		color: #999999;
		font-size: 20px;
	}

	.region-tab_top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #E2EBFF;
		font-weight: bold;
		width: 100%;
	}


	.tab_top {
		width: 25%;
		background-color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tab_top p {
		width: 100%;
		height: 80px;
		text-align: center;
		line-height: 80px;
	}

	.lfCss p {
		background-color: #E2EBFF !important;
		border-radius: 35px 35px 0 0;
		width: 100%;
		height: 80px;
		text-align: center;
		line-height: 80px;
	}

	/* 激活标签后方标签样式 */
	.lfCss+.tab_top {
		border-radius: 0 0 0 35px;
	}

	.tab_top:last-child.lfCss p {
		border-radius: 35px 0 0 0 !important;
	}

	.tab_top:first-child.lfCss p {
		border-radius: 0 35px 0 0 !important;
	}

	.rgCss {
		border-radius: 0 0 35px 0 !important;
	}

	.dingBacs {
		position: relative;
	}

	.dingBac {
		width: 750px;
		height: 402px;
		background: linear-gradient(180deg, #E2EBFF 0%, #FFFFFF 100%);
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
	}
</style>